module.exports = __webpack_public_path__ + "img/art_artwork_fantasy_artistic_original_5000x3046.2008b185.jpg";